import { Flex, Text } from '@grammarly/design-system'

import { SignUpProductRecButton } from '@components/item/cta-button/signup-product-recommendation'
import { ButtonColor } from '@components/ui-lib/button'
import { useTool } from '../tool-context'

import styles from '../tool.module.scss'

export const ToolFooterBanner = () => {
  const { footerBannerCopy } = useTool()

  return (
    <Flex
      gap={4}
      marginTop={6}
      bgColor="purple-100"
      borderRadius={2}
      padding={4}
      margin="0 auto"
      justify="center"
      align="center"
      className={styles.toolFooterBannerContainer}
    >
      <Text variant="text-large" as="span" color="base-inverse">
        {footerBannerCopy}
      </Text>
      <SignUpProductRecButton
        compact
        color={ButtonColor.WDK24WhiteBlackText}
        text={
          <Text variant="text-large" as="span" color="base-default">
            <b>Get Grammarly</b>
            &nbsp;&nbsp;It&apos;s Free
          </Text>
        }
        toQueryParam="editor"
      />
    </Flex>
  )
}
